import {CloudDownloadOutlined, CloudUploadOutlined, MailOutlined} from "@ant-design/icons";
import {useNavigate} from "react-router-dom";
import {getExportTemplateSalaryTable} from "../../../../../api/hrm/wage/salary";
import {Menu} from "antd";
import i18next from "../../../../../translation/i18n"
import {getMe} from "../../../../../api/system/admin/user-account";

const {t} = i18next

export default function ContextMenuListSalary({
                                                  id,
                                                  setIsModalVisible,
                                                  status,
                                                  setType,
                                                  salaryConfigId,
                                                  setShowDocument,disabled,
                                                  creatorId

                                              }) {

    let navigate = useNavigate();

    const showModal = (value) => {
        if (value !== 'update') {
            setIsModalVisible(true)
        } else {
            if (salaryConfigId && salaryConfigId !== 0) {
                navigate("/hrm/timekeeping/wage/template/update/" + salaryConfigId)
            } else {
                navigate("/hrm/timekeeping/wage/table/manual-add/" + id)
            }
        }
        setType(value)
    }

    const showModalSendMail = (value) => {
        if (value === 'uploadTemplateSalary') {
            setShowDocument(true)
        } else if (value === 'downloadTemplateSalary') {
            getExportTemplateSalaryTable(id,t).then((res => {
                const url = window.URL.createObjectURL(new Blob([res?.content]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download',
                    res?.fileName);
                document.body.appendChild(link);
                link.click();
            }));
        } else {
            navigate("/hrm/timekeeping/wage/table/notify/" + id)
        }
    }

    function getItem(label,
                     key,
                     icon, disabled,
                     children) {
        return {
            key,
            icon,
            children,
            label,
            disabled,

        };
    }
    
    const isCreator = ( creatorId === getMe()?.accountId || creatorId === 0)
    // const isCreator = true

    const items = [
        // getItem(
        //     status !== 'approved' ? t("tnp.components.timesheetViewport.text47") : t("tnp.components.salary.text1"),
        //     'updateStatus',
        //     status !== 'approved' ? <CheckCircleTwoTone twoToneColor="#52c41a"/> : <UndoOutlined/>,disabled
        // ),
        // status === 'draft' && isCreator && getItem(
        //     t("tnp.button.edit1"),
        //     'update',
        //     <EditOutlined/>,disabled
        // ),

        // status !== 'approved' && isCreator && getItem(
        //     t("tnp.button.delete"),
        //     'remove',
        //     <DeleteOutlined/>,disabled
        // ),
        getItem(
            t("tnp.components.salary.text2"),
            'sendMail',
            <MailOutlined twoToneColor="#52c41a"/>,disabled
        ),
        getItem(
            t("tnp.components.salary.text3"),
            'uploadTemplateSalary',
            <CloudUploadOutlined twoToneColor="#52c41a"/>,disabled
        ),
        getItem(
            t("tnp.components.salary.text4"),
            'downloadTemplateSalary',
            <CloudDownloadOutlined twoToneColor="#52c41a"/>
        ),
    ]

    const handleClickMenu = (e) => {
        switch (e.key) {
            case 'updateStatus':
                showModal('updateStatus')
                break;
            case 'update':
                showModal('update')
                break;
            case  'remove':
                showModal('remove')
                break;
            case  'sendMail':
                showModalSendMail('updateStatus')
                break;
            case  'uploadTemplateSalary':
                showModalSendMail('uploadTemplateSalary')
                break;
            case  'downloadTemplateSalary':
                showModalSendMail('downloadTemplateSalary')
                break;
            default :
                break;
        }
    }

    return (

        <>
            <Menu
                className={"context-menu"}
                items={items}
                onClick={handleClickMenu}
            />
        </>

    )
}